import React from 'react'

interface MailIconProps {
  color?: string
  gradient?: boolean
  width?: number
  height?: number
  alt?: string
}

const MailIcon: React.FC<MailIconProps> = ({
  color = '#000',
  gradient,
  width = 24,
  height = 24,
  alt = 'Mail icon',
}) => {
  const gradientColors = { start: '#ed1c24', end: '#27aae1' }

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      fill='none'
      viewBox='0 0 24 24'
      aria-label={alt}
    >
      <title>{alt}</title>
      {gradient ? (
        <defs>
          <linearGradient id='grad1' x1='0%' y1='0%' x2='100%' y2='0%'>
            <stop offset='0%' style={{ stopColor: gradientColors.start, stopOpacity: 1 }} />
            <stop offset='100%' style={{ stopColor: gradientColors.end, stopOpacity: 1 }} />
          </linearGradient>
        </defs>
      ) : null}
      <path
        fill={gradient ? 'url(#grad1)' : color}
        d='M17.023 6.797H14.93V5.203h4.512a.704.704 0 00.598-1.065l-.903-1.517.907-1.563A.704.704 0 0019.442 0h-5.21a.7.7 0 00-.697.703v6.094H6.977C4.233 6.797 2 9.047 2 11.813V19.5a.7.7 0 00.698.703h7.86v3.094a.7.7 0 00.698.703.7.7 0 00.697-.703v-3.094h1.582v3.094a.7.7 0 00.698.703.7.7 0 00.697-.703v-3.094h6.372A.7.7 0 0022 19.5v-7.688c0-2.765-2.233-5.015-4.977-5.015zm-2.093-5.39h3.295l-.502.863a.708.708 0 00.004.717l.483.81h-3.28v-2.39zM3.395 11.811c0-1.99 1.607-3.609 3.582-3.609 1.975 0 3.581 1.62 3.581 3.61v6.984H3.395v-6.985zm17.21 6.985h-8.652v-6.985a5.02 5.02 0 00-1.524-3.609h3.106v1.922a.7.7 0 00.698.703.7.7 0 00.697-.703V8.203h2.093c1.975 0 3.582 1.62 3.582 3.61v6.984z'
      />
    </svg>
  )
}

export default MailIcon
